export const ENROLL_FORM =
  'https://docs.google.com/forms/d/1wbV4oxf4qJIN8kRu5t-41224IsZnx8m65U9nG4oG-jE/viewform';

export const PARTNER_FORM =
  'https://docs.google.com/forms/d/1UShmUI9_dMslWepxsNS7xf2t0XUlCl3ebdSmaF9OSHo/viewform';

export const BROCHURE_PDF = '/docs/FutureLeadX-Brochure.pdf';
